import { useQuery, useMutation, useQueryClient } from 'react-query';
import {
    MarkNotificationRead,
    GetUserNotifications,
} from '../services/backend';
import { Notify, NotifyError } from '../utils/functions';

export function useGetUserNotifications() {
    return useQuery('user-notifications', () => GetUserNotifications(), {
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
        select: (data) => {
            return data?.data || [];
        },
        onError: (error) => {
            NotifyError("Failed to fetch user notifications", error);
            console.error("Error fetching user notifications:", error);
        }
    });
}

export function useMarkNotificationRead() {
    const queryClient = useQueryClient();
    return useMutation(({ notificationId }) => MarkNotificationRead(notificationId), {
        onSuccess: () => {
            queryClient.invalidateQueries('user-notifications');
            Notify("Notification marked as read", "success");
        },
        onError: (error) => {
            NotifyError("Failed to mark notification as read", error);
            console.error("Error marking notification as read:", error);
        }
    });
}